





// import React, { useEffect, useState } from "react";
// import { Card, Row, Col, Form, Button, Badge, Spinner } from "react-bootstrap";
// import { useNavigate, useParams } from "react-router-dom";
// import { CompanyService } from "Services/CompanyService";
// import { toast } from "react-toastify";
// import "./editCompany.css";

// const EditCompany = () => {
//   const navigate = useNavigate();
//   const { id } = useParams();

//   const [loading, setLoading] = useState(false);

//   const [formData, setFormData] = useState<any>({
//     company_code: "",
//     name: "",
//     email: "",
//     phone: "",
//     address: "",
//     status: "ACTIVE",
//     max_candidates: 0,
//     max_exams: 0,
//     max_proctors: 0,
//     ai_features: [],
//   });

//   // ================= FETCH COMPANY DETAILS =================
//   const fetchCompanyDetails = async () => {
//     try {
//       setLoading(true);
//       const res = await CompanyService.getCompanyById(id!);

//       if (res?.status === 200) {
//         const data = res.data?.data;

//         setFormData({
//           company_code: data.company_code,
//           name: data.name,
//           email: data.email,
//           phone: data.phone,
//           address: data.address,
//           status: data.status?.toUpperCase(),
//           max_candidates: data.controls?.max_candidates,
//           max_exams: data.controls?.max_exams,
//           max_proctors: data.controls?.max_proctors,
//           ai_features: data.ai_features || [],
//         });
//       }
//     } catch (err) {
//       toast.error("Failed to fetch company details");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (id) {
//       fetchCompanyDetails();
//     }
//   }, [id]);

//   // ================= HANDLE INPUT =================
//   const handleChange = (e: any) => {
//     const { name, value } = e.target;

//     setFormData({
//       ...formData,
//       [name]:
//         name.includes("max_") ? Number(value) : value,
//     });
//   };

//   // ================= AI FEATURE TOGGLE =================
//   const handleFeatureToggle = (feature: string) => {
//     const exists = formData.ai_features.includes(feature);

//     if (exists) {
//       setFormData({
//         ...formData,
//         ai_features: formData.ai_features.filter((f: string) => f !== feature),
//       });
//     } else {
//       setFormData({
//         ...formData,
//         ai_features: [...formData.ai_features, feature],
//       });
//     }
//   };

//   // ================= UPDATE COMPANY =================
//   const handleUpdateCompany = async () => {
//     try {
//       setLoading(true);

//       const payload = {
//         name: formData.name,
//         // email: formData.email,
//         phone: formData.phone,
//         address: formData.address,
//         // status: formData.status.toLowerCase(),
//         controls: {
//           max_candidates: formData.max_candidates,
//           max_exams: formData.max_exams,
//           max_proctors: formData.max_proctors,
//         },
//         ai_features: formData.ai_features,
//       };

//       const res = await CompanyService.updateCompany(id!, payload);

//       if (res?.status === 200) {
//         toast.success("Company updated successfully");
//         navigate(-1);
//       }
//     } catch (err) {
//       toast.error("Update failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="edit-company-page">

//       {loading && (
//         <div className="text-center py-3">
//        <Spinner animation="border" size="sm" />
//         </div>
//       )}

//       <div className="edit-header">
//         <div>
//           <h3 className="fw-bold mb-1">Edit Company</h3>
//           <Badge bg="dark" className="px-3 py-2">
//             {formData.company_code}
//           </Badge>
//         </div>

//         <Button variant="light" onClick={() => navigate(-1)}>
//           ← Back
//         </Button>
//       </div>

//       {/* BASIC INFO */}
//       <Card className="edit-card mb-4">
//         <Card.Body>
//           <h5 className="section-title mb-4">Basic Information</h5>

//           <Row>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Company Name</Form.Label>
//                 <Form.Control
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Email</Form.Label>
//                 <Form.Control
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Phone</Form.Label>
//                 <Form.Control
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Status</Form.Label>
//                 <Form.Select
//                   name="status"
//                   value={formData.status}
//                   onChange={handleChange}
//                 >
//                   <option value="ACTIVE">ACTIVE</option>
//                   <option value="INACTIVE">INACTIVE</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col> */}

//             <Col md={12}>
//               <Form.Group>
//                 <Form.Label>Address</Form.Label>
//                 <Form.Control
//                   as="textarea"
//                   rows={3}
//                   name="address"
//                   value={formData.address}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* CONTROLS */}
//       <Card className="edit-card mb-4">
//         <Card.Body>
//           <h5 className="section-title mb-4">Controls</h5>

//           <Row>
//             <Col md={4}>
//               <Form.Control
//                 type="number"
//                 name="max_candidates"
//                 value={formData.max_candidates}
//                 onChange={handleChange}
//               />
//             </Col>

//             <Col md={4}>
//               <Form.Control
//                 type="number"
//                 name="max_exams"
//                 value={formData.max_exams}
//                 onChange={handleChange}
//               />
//             </Col>

//             <Col md={4}>
//               <Form.Control
//                 type="number"
//                 name="max_proctors"
//                 value={formData.max_proctors}
//                 onChange={handleChange}
//               />
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* AI FEATURES */}
//       <Card className="edit-card mb-4">
//         <Card.Body>
//           <h5 className="section-title mb-3">AI Features</h5>

//           <div className="feature-toggle-group">
//             {["face detection", "screen recording"].map((feature) => (
//               <Button
//                 key={feature}
//                 className={`feature-toggle ${
//                   formData.ai_features.includes(feature)
//                     ? "active-feature"
//                     : ""
//                 }`}
//                 onClick={() => handleFeatureToggle(feature)}
//               >
//                 {feature}
//               </Button>
//             ))}
//           </div>
//         </Card.Body>
//       </Card>

//       <div className="text-end">
//         <Button
//           className="save-btn px-4"
//           onClick={handleUpdateCompany}
//           disabled={loading}
//         >
//           Update Company
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default EditCompany;





import React, { useEffect, useState } from "react";
import { Card, Row, Col, Form, Button, Badge, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { CompanyService } from "Services/CompanyService";
import { toast } from "react-toastify";
import "./editCompany.css";

const EditCompany = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [allFeatures, setAllFeatures] = useState<string[]>([]);

  const [formData, setFormData] = useState<any>({
    company_code: "",
    name: "",
    email: "",
    phone: "",
    address: "",
    status: "ACTIVE",
    max_candidates: 0,
    max_exams: 0,
    max_proctors: 0,
    ai_features: [],
  });

  // ================= FETCH ALL AI FEATURES =================
  const fetchAllFeatures = async () => {
    try {
      const res = await CompanyService.getAIFeatures();
      if (res?.status === 200) {
        setAllFeatures(res.data?.data || []);
      }
    } catch (err) {
      toast.error("Failed to fetch AI features");
    }
  };

  // ================= FETCH COMPANY DETAILS =================
  const fetchCompanyDetails = async () => {
    try {
      setLoading(true);
      const res = await CompanyService.getCompanyById(id!);

      if (res?.status === 200) {
        const data = res.data?.data;

        setFormData({
          company_code: data.company_code,
          name: data.name,
          email: data.email,
          phone: data.phone,
          address: data.address,
          status: data.status?.toUpperCase(),
          max_candidates: data.controls?.max_candidates,
          max_exams: data.controls?.max_exams,
          max_proctors: data.controls?.max_proctors,
          ai_features: data.ai_features || [],
        });
      }
    } catch (err) {
      toast.error("Failed to fetch company details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchCompanyDetails();
      fetchAllFeatures();
    }
  }, [id]);

  // ================= HANDLE INPUT =================
  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: name.includes("max_") ? Number(value) : value,
    });
  };

  // ================= AI FEATURE TOGGLE =================
  const handleFeatureToggle = (feature: string) => {
    const exists = formData.ai_features.includes(feature);

    if (exists) {
      setFormData({
        ...formData,
        ai_features: formData.ai_features.filter((f: string) => f !== feature),
      });
    } else {
      setFormData({
        ...formData,
        ai_features: [...formData.ai_features, feature],
      });
    }
  };

  // ================= UPDATE COMPANY =================
  const handleUpdateCompany = async () => {
    try {
      setLoading(true);

      const payload = {
        name: formData.name,
        phone: formData.phone,
        address: formData.address,
        controls: {
          max_candidates: formData.max_candidates,
          max_exams: formData.max_exams,
          max_proctors: formData.max_proctors,
        },
        ai_features: formData.ai_features,
      };

      const res = await CompanyService.updateCompany(id!, payload);

      if (res?.status === 200) {
        toast.success("Company updated successfully");
        navigate(-1);
      }
    } catch (err) {
      toast.error("Update failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="edit-company-page">
      {loading && (
        <div className="text-center py-3">
          <Spinner animation="border" size="sm" />
        </div>
      )}

      <div className="edit-header">
        <div>
          <h3 className="fw-bold mb-1">Edit Company</h3>
          <Badge bg="dark" className="px-3 py-2">
            {formData.company_code}
          </Badge>
        </div>

        <Button variant="light" onClick={() => navigate(-1)}>
          ← Back
        </Button>
      </div>

      {/* BASIC INFO */}
      <Card className="edit-card mb-4">
        <Card.Body>
          <h5 className="section-title mb-4">Basic Information</h5>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* CONTROLS */}
      <Card className="edit-card mb-4">
        <Card.Body>
          <h5 className="section-title mb-4">Controls</h5>

          <Row>
            <Col md={4}>
              <Form.Control
                type="number"
                name="max_candidates"
                value={formData.max_candidates}
                onChange={handleChange}
              />
            </Col>

            <Col md={4}>
              <Form.Control
                type="number"
                name="max_exams"
                value={formData.max_exams}
                onChange={handleChange}
              />
            </Col>

            <Col md={4}>
              <Form.Control
                type="number"
                name="max_proctors"
                value={formData.max_proctors}
                onChange={handleChange}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* AI FEATURES */}
      <Card className="edit-card mb-4">
        <Card.Body>
          <h5 className="section-title mb-3">AI Features</h5>

          <div className="feature-toggle-group">
            {allFeatures.map((feature) => {
              const isActive = formData.ai_features.includes(feature);

              return (
                <Button
                  key={feature}
                  className={`feature-toggle ${
                    isActive ? "active-feature" : "inactive-feature"
                  }`}
                  onClick={() => handleFeatureToggle(feature)}
                >
                  {feature}
                </Button>
              );
            })}
          </div>
        </Card.Body>
      </Card>

      <div className="text-end">
        <Button
          className="save-btn px-4"
          onClick={handleUpdateCompany}
          disabled={loading}
        >
          Update Company
        </Button>
      </div>
    </div>
  );
};

export default EditCompany;